import {
  FETCH_PATIENT_QUEUE_REQUEST,
  FETCH_PATIENT_QUEUE_SUCCESS,
  FETCH_PATIENT_QUEUE_FAILURE,
  SET_SELECTED_PATIENT,
  PROCESS_PAYMENT_REQUEST,
  PROCESS_PAYMENT_SUCCESS,
  PROCESS_PAYMENT_FAILURE,
  UPDATE_PATIENT_REVIEW
} from "../types/CounsellorTypes";

const initialState = {
  patientQueue: [],
  selectedPatient: null,
  loading: false,
  error: null,
  paymentLoading: false,
  paymentError: null,
  lastPaymentResult: null,
};

const counsellorReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PATIENT_QUEUE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_PATIENT_QUEUE_SUCCESS:
      return {
        ...state,
        loading: false,
        // patientQueue: action.payload?.data || [], 
        patientQueue: action.payload || [],// ✅ FIX
        error: null,
      };
    case FETCH_PATIENT_QUEUE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case SET_SELECTED_PATIENT:
      return {
        ...state,
        selectedPatient: action.payload,
        paymentError: null, // Reset payment error when selecting new patient
        lastPaymentResult: null, // Reset payment result when selecting new patient
      };
    case PROCESS_PAYMENT_REQUEST:
      return {
        ...state,
        paymentLoading: true,
        paymentError: null,
      };
    case PROCESS_PAYMENT_SUCCESS:
      return {
        ...state,
        paymentLoading: false,
        lastPaymentResult: action.payload,
        paymentError: null,
      };
    case PROCESS_PAYMENT_FAILURE:
      return {
        ...state,
        paymentLoading: false,
        paymentError: action.payload,
      };
    case UPDATE_PATIENT_REVIEW:
      return {
        ...state,
        patientQueue: state.patientQueue.map((patient) =>
          patient.patient_id === action.payload.patientId
            ? {
              ...patient,
              ...(action.payload.field === "googleReview" && {
                review_provided: action.payload.value ? "Yes" : "No",
              }),
              ...(action.payload.field === "testimonial" && {
                testimonial_provided: action.payload.value ? "Yes" : "No",
              }),
            }
            : patient
        ),

        // ✅ ALSO UPDATE selectedPatient
        selectedPatient:
          state.selectedPatient?.patient_id === action.payload.patientId
            ? {
              ...state.selectedPatient,
              ...(action.payload.field === "googleReview" && {
                review_provided: action.payload.value ? "Yes" : "No",
              }),
              ...(action.payload.field === "testimonial" && {
                testimonial_provided: action.payload.value ? "Yes" : "No",
              }),
            }
            : state.selectedPatient,
      };
    default:
      return state;
  }
};

export default counsellorReducer;
